import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClock,
  faDrumstickBite,
  faLeaf,
  faTruckFast,
} from "@fortawesome/free-solid-svg-icons";
import "./WhyChooseUs.scss";

const points = [
  {
    icon: faLeaf,
    title: "Fresh Ingredients",
    text: "Prepared daily for clean, bold flavor in every bite.",
  },
  {
    icon: faTruckFast,
    title: "Fast Delivery",
    text: "Hot shawarma and meals delivered quickly in Business Bay.",
  },
  {
    icon: faClock,
    title: "Open Until 4 AM",
    text: "Late-night cravings covered with fresh orders until 4 AM.",
  },
  {
    icon: faDrumstickBite,
    title: "Premium Meat",
    text: "Quality chicken and meat selected for rich, authentic taste.",
  },
];

function WhyChooseUs() {
  return (
    <section className="why-choose" aria-labelledby="why-choose-title">
      <div className="why-choose__inner">
        <div className="why-choose__heading">
          <p>Why Choose Us</p>
          <h2 id="why-choose-title">Fresh, Fast, and Made for Shawarma Fans</h2>
        </div>

        <div className="why-choose__grid">
          {points.map((point) => (
            <article className="why-choose__item" key={point.title}>
              <span className="why-choose__icon" aria-hidden="true">
                <FontAwesomeIcon icon={point.icon} />
              </span>
              <h3>{point.title}</h3>
              <p>{point.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default WhyChooseUs;
